import { provideHttpClient } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { provideNgxMask } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { MainLayoutModule } from './modules/main-layout/main-layout.module';
import { ConfigService } from './services/web/config.service';

const appInitializerFn = (configService: ConfigService) => async () => await configService.loadAppConfig();

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    RouterModule.forRoot(routes, {}),
    BrowserAnimationsModule,
    BrowserModule,
    MainLayoutModule,
    ToastrModule.forRoot({
      maxOpened: 5,
      timeOut: 5000,
      extendedTimeOut: 2000,
      newestOnTop: false
    })
  ],
  providers: [
    ConfigService,
    provideAppInitializer(() => {
        const initializerFn = (appInitializerFn)(inject(ConfigService));
        return initializerFn();
      }),
    provideHttpClient(),
    ...provideNgxMask(),
    DeviceDetectorService
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
  constructor() { }
}
